import { FunctionComponent } from "react";
import ReactMarkdown, { Components } from "react-markdown";
import {
  StyledMDStrong,
  StyledMDParagraph,
  StyledMDUl,
  StyledMDOl,
  StyledMDLi,
  StyledMarkdown,
  StyledMDTitle,
  StyledA,
} from "./markdown.styles";

interface MarkdownProps {
  children: string;
}

const pre = (str: string) => {
  // this replaces normal linebreaks with two linebreaks, make it prettier and forces use of <p> - to avoid this add <br/>
  return str.replace(/\n/gi, "\n\n");
};

const Markdown: FunctionComponent<MarkdownProps> = ({ children }) => {
  return (
    <StyledMarkdown>
      <ReactMarkdown
        allowedElements={[
          "h1",
          "h2",
          "p",
          "strong",
          "br",
          "ul",
          "ol",
          "li",
          "a",
        ]}
        components={components}
      >
        {pre(children)}
      </ReactMarkdown>
    </StyledMarkdown>
  );
};

export default Markdown;

// define mapping
const components: Partial<Components> = {
  h1({ children }) {
    return <StyledMDTitle level="h2">{children}</StyledMDTitle>;
  },
  p({ children }) {
    return <StyledMDParagraph>{children}</StyledMDParagraph>;
  },
  strong({ children }) {
    return <StyledMDStrong>{children}</StyledMDStrong>;
  },
  ul({ children }) {
    return <StyledMDUl>{children}</StyledMDUl>;
  },
  ol({ children }) {
    return <StyledMDOl>{children}</StyledMDOl>;
  },
  li({ children }) {
    return <StyledMDLi>{children}</StyledMDLi>;
  },
  a({ node, ...props }) {
    return <StyledA {...props} target="_blank" rel="noopener noreferrer" />;
  },
};
